import { imgBaseUrl } from './env'
/**
 * 存储sessionStorage
 */
export const setStore = (name, content) => {
    if (!name) return
    if (typeof content !== 'string') {
        content = JSON.stringify(content)
    }
    window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getStore = name => {
    if (!name) return
    return JSON.parse(window.sessionStorage.getItem(name))
}

/**
 * 删除sessionStorage
 */
export const removeStore = name => {
    if (!name) return
    window.sessionStorage.removeItem(name)
}

/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
    let target
    // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
    if (attr === 'scrollTop') {
        target = element.scrollTop
    } else if (element.currentStyle) {
        target = element.currentStyle[attr]
    } else {
        target = document.defaultView.getComputedStyle(element, null)[attr]
    }
    // 在获取 opactiy 时需要获取小数 parseFloat
    return NumberMode === 'float' ? parseFloat(target) : parseInt(target)
}

/**
 * 页面到达底部，加载更多
 */
export const loadMore = (element, callback) => {
    let windowHeight = window.screen.height
    let height
    let setTop
    let paddingBottom
    let marginBottom
    let requestFram
    let oldScrollTop

    document.body.addEventListener('scroll', () => {
        loadMore()
    }, false)
    // 运动开始时获取元素 高度 和 offseTop, pading, margin
    element.addEventListener('touchstart', () => {
        height = element.offsetHeight
        setTop = element.offsetTop
        paddingBottom = getStyle(element, 'paddingBottom')
        marginBottom = getStyle(element, 'marginBottom')
    }, {passive: true})

    // 运动过程中保持监听 scrollTop 的值判断是否到达底部
    element.addEventListener('touchmove', () => {
        loadMore()
    }, {passive: true})

    // 运动结束时判断是否有惯性运动，惯性运动结束判断是非到达底部
    element.addEventListener('touchend', () => {
        oldScrollTop = document.body.scrollTop
        moveEnd()
    }, {passive: true})

    const moveEnd = () => {
        requestFram = requestAnimationFrame(() => {
            if (document.body.scrollTop !== oldScrollTop) {
                oldScrollTop = document.body.scrollTop
                loadMore()
                moveEnd()
            } else {
                cancelAnimationFrame(requestFram)
                // 为了防止鼠标抬起时已经渲染好数据从而导致重获取数据，应该重新获取dom高度
                height = element.offsetHeight
                loadMore()
            }
        })
    }

    const loadMore = () => {
        if (document.body.scrollTop + windowHeight >= height + setTop + paddingBottom + marginBottom) {
            callback()
        }
    }
}

/**
 * 显示返回顶部按钮，开始、结束、运动 三个过程中调用函数判断是否达到目标点
 */
export const showBack = callback => {
    let requestFram
    let oldScrollTop

    document.addEventListener('scroll', () => {
        showBackFun()
    }, false)
    document.addEventListener('touchstart', () => {
        showBackFun()
    }, {passive: true})

    document.addEventListener('touchmove', () => {
        showBackFun()
    }, {passive: true})

    document.addEventListener('touchend', () => {
        oldScrollTop = document.body.scrollTop
        moveEnd()
    }, {passive: true})

    const moveEnd = () => {
        requestFram = requestAnimationFrame(() => {
            if (document.body.scrollTop !== oldScrollTop) {
                oldScrollTop = document.body.scrollTop
                moveEnd()
            } else {
                cancelAnimationFrame(requestFram)
            }
            showBackFun()
        })
    }

    // 判断是否达到目标点
    const showBackFun = () => {
        if (document.body.scrollTop > 500) {
            return (true)
        } else {
            return (false)
        }
    }
    
}

export const getDay =(day) =>{
    var today = new Date();    
        
    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;            
    
    today.setTime(targetday_milliseconds); //注意，这行是关键代码  
        
    var tYear = today.getFullYear();    
    var tMonth = today.getMonth();    
    var tDate = today.getDate();    
    tMonth = doHandleMonth(tMonth + 1);    
    tDate = doHandleMonth(tDate);    
    return tYear+"-"+tMonth+"-"+tDate;    
}

const doHandleMonth =(month) =>{    
    var m = month;    
    if(month.toString().length == 1){    
        m = "0" + month;    
    }    
    return m;    
}

export const  dateFormat= (Date,fmt)=> { //author: meizz

    var o = {
        "M+": Date.getMonth() + 1, //月份 
        "d+": Date.getDate(), //日 
        "h+": Date.getHours(), //小时 
        "m+": Date.getMinutes(), //分 
        "s+": Date.getSeconds(), //秒 
        "q+": Math.floor((Date.getMonth() + 3) / 3), //季度 
        "S": Date.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (Date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export const getUUID = function () {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "";
    var uuid = s.join("");
    return uuid;
}

export const getAllDate = function () {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return year + month + day;
}
export const imgURL = (headImg,client) => {
    // console.log(headImg)
    if(headImg == null || headImg == undefined || headImg == ""){
        return require('../images/friend.png');
    }
    else{
        let imgUrl=headImg.split('?')[0];
        // console.log(reportUrl)
        return imgUrl;
    }
    
}


// WEBPACK FOOTER //
// ./src/config/mUtils.js